import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const t = i((a, e) => /* @__PURE__ */ s.jsx(
  o,
  {
    ref: e,
    ...a,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3620",
              width: 14,
              height: 16,
              x: 1,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M11.114 14.6h-6.21a.625.625 0 1 0 0 1.25h6.21a.625.625 0 1 0 0-1.25M13.597 9.658c.182-.3.558-.434.874-.282.314.151.448.53.27.831A7.73 7.73 0 0 1 8.12 14a7.64 7.64 0 0 1-6.838-4.18.59.59 0 0 1 .317-.81c.32-.132.686.023.848.33a6.38 6.38 0 0 0 4.963 3.35v-1.81c-1.7-.3-3-1.78-3-3.56V3.71C4.41 1.72 6.04.09 8.03.09s3.62 1.62 3.62 3.62v2.67a.62.62 0 0 1-1.24 0V3.71c0-1.31-1.07-2.38-2.38-2.38S5.65 2.4 5.65 3.71v3.61c0 1.31 1.07 2.38 2.38 2.38.316 0 .62.229.62.545V12.7a6.45 6.45 0 0 0 4.948-3.042"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3620)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0-.1h16v16H0z" }) })
        ]
      }
    )
  }
));
t.displayName = "AgencyMicIcon";
export {
  t as AgencyMicIcon,
  t as default
};
//# sourceMappingURL=index.js.map
